import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class BookingsService {
  constructor(private http: HttpClient, private restService: RestService) {}

  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('bookings/search', val_params);
  }
  
  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('bookings/list', val_params);
  }

  toursPending(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('bookings/tours/pending', val_params);
  }

  toursOpen(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('bookings/tours/status_open', val_params);
  }

  get(val_id: number) {
    return this.restService.get('bookings/edit', val_id);
  }

  getTransferData(val_id: number) {
    return this.restService.get('bookings/transfer', val_id);
  }

  detail(val_id: number) {
    return this.restService.get('bookings/detail', val_id);
  }

  auditing(val_id: number) {
    return this.restService.get('bookings/auditing', val_id);
  }

  save(data: any) {
    return this.restService.save('bookings/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('bookings/update/save', data);
  }


  update(val_id: number, data: any) {
    return this.restService.update('bookings/update', val_id, data);
  }

  checkin(val_id: number, data: any) {
    return this.restService.update('bookings/checkin', val_id, data);
  }

  checkout(val_id: number, data: any) {
    return this.restService.update('bookings/checkout', val_id, data);
  }

  recover(val_id: number, data: any) {
    return this.restService.update('bookings/recover', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('bookings/delete', val_id);
  }

  // TRANSFERS =============

  listTransfers(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('transfers/list', val_params);
  }

  saveTransfers(data: any) {
    return this.restService.save('transfers/save', data);
  }

  updateTransfer(val_id: number, data: any) {
    return this.restService.update('transfers/update', val_id, data);
  }

  deleteTransfers(val_id: number) {
    return this.restService.delete('transfers/delete', val_id);
  }

   // RECEIVEDS =============

   listReceiveds(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('receiveds/list', val_params);
  }

  saveReceiveds(data: any) {
    return this.restService.save('receiveds/save', data);
  }

  updateReceiveds(val_id: number, data: any) {
    return this.restService.update('receiveds/update', val_id, data);
  }

  deleteReceiveds(val_id: number) {
    return this.restService.delete('receiveds/delete', val_id);
  }

   // ARRIVALS =============

   listArrivals(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('arrivals/list', val_params);
  }

  pickupHotel(val_id: number, data: any) {
    return this.restService.update('arrivals/pickup_hotel', val_id, data);
  }

  pickupCoolaborator(val_id: number, data: any) {
    return this.restService.update('arrivals/pickup_collaborator', val_id, data);
  }

  resetPickup(val_id: number, data: any) {
    return this.restService.update('arrivals/reset_pickup', val_id, data);
  }

  //  reports bookings
  reportsummaryAdviser(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('report/bookings/summary_adviser', val_params);
  }

  reportHistoryMonthAdviser(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('report/bookings/history_month_adviser', val_params);
  }

  reportHistoryTourAdviser(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('report/bookings/history_tour_adviser', val_params);
  }
  
}
